import { z } from 'zod';

const ROLE_LABELS: Record<string, string> = { ss_admin: 'SS Admin', accounts: 'Accounts' };

// An account created before roles has none; its tabs are whatever it was left with.
export const roleLabel = (role: string | null): string =>
  role ? (ROLE_LABELS[role] ?? role) : 'Custom';

// An account holding a tab the viewer doesn't can't be suspended or reactivated by this
// viewer. The API enforces it; this only greys out what would be refused.
export const holdsMoreThan = (screens: readonly string[], assignable: readonly string[]) =>
  screens.some((screen) => !assignable.includes(screen));

// Mirrors the API's own rules so most mistakes are caught before the request. The API
// still has the last word (an email already in use only shows up there). There is no
// username: the API makes an internal handle from the email, and sign-in is by email.
// The same 10-digit rule as a resident's mobile. Spaces are dropped, as the API does.
export const mobileSchema = z
  .string()
  .transform((value) => value.replace(/\s+/g, ''))
  .pipe(
    z
      .string()
      .min(1, 'Enter their mobile number')
      .regex(/^\d{10}$/, 'Enter a 10-digit mobile number'),
  );

export const newAdministratorSchema = z.object({
  name: z.string().trim().min(1, 'Enter a name'),
  email: z.string().trim().email('Enter a valid email'),
  mobile: mobileSchema,
});

export type INewAdministratorForm = z.infer<typeof newAdministratorSchema>;

// The resident app's password field takes exactly 6 digits.
export const PIN_PATTERN = /^\d{6}$/;
